import { render, staticRenderFns } from "./ToggleDetails.vue?vue&type=template&id=565e6150&"
import script from "./ToggleDetails.vue?vue&type=script&lang=js&"
export * from "./ToggleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports